export default __webpack_public_path__ + "static/imaging-e49187a0712c7adb39ee3a9de56e800c.jpeg";